//
//
//
//
//
//
//

import InputlabelBlock from 'components/blocks/InputLabel.vue'

export default {
  props: ['label','text','disabled','invalid'],
  components: {
    InputlabelBlock,
  },
  data() {
    return {
      inputText: ''
    }
  },
  methods: {
    changeText(event) {
      this.inputText = event.target.value;
      this.$emit('textChanged', this.inputText);
    },
    setFocus() {
      this.inputText = '';
      event.target.value = '';
    },
    unsetFocus() {
      if (event.target.value == ''){
        this.inputText = this.text;
        event.target.value = this.text;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./components/combinedBlocks/InputForm.vue